import cn from "classnames"
import { Field, FieldProps } from "formik"
import React, { ChangeEvent } from "react"
import { useTranslation } from "react-i18next"

import { getRequiredMessage } from "~/components/Form/helpers"

import styles from "./index.module.css"

type InputProps = JSX.IntrinsicElements["textarea"] & {
  label: string
  active?: boolean
  error?: boolean
  errorMessage?: string
  isActive?: boolean
  isRequired?: boolean
  onChange: (e: ChangeEvent<any>) => void
}

export const TextArea: React.FC<InputProps> = ({
  className,
  label,
  error,
  errorMessage,
  value,
  isRequired,
  onChange,
  ...properties
}) => (
  <div className={cn(styles.Wrapper, className)}>
    <textarea
      className={cn({
        [styles._active]: !!value,
        [styles._error]: error,
      })}
      id={label}
      value={value}
      onChange={onChange}
      {...properties}
    />

    <label>{isRequired ? `${label} *` : label}</label>

    {errorMessage && <div className={styles.ErrorMessage}>{errorMessage}</div>}
  </div>
)

type FormTextArea = {
  label: string
  active?: boolean
  className?: string
  name: string
  isRequired?: boolean
}

export const FormTextArea: React.FC<FormTextArea> = ({
  className,
  label,
  name,
  isRequired,
  ...properties
}) => {
  const { t } = useTranslation()

  return (
    <Field name={name}>
      {({ field, meta }: FieldProps) => (
        <TextArea
          className={className}
          error={!!meta.error && meta.touched}
          errorMessage={getRequiredMessage(t, meta, isRequired)}
          isRequired={isRequired}
          label={label}
          value={meta.value}
          {...field}
          {...properties}
        />
      )}
    </Field>
  )
}
